'use client';
import VideosPagination from '@/modules/players/v2/tabs/videos/VideosPagination';
import VideosTournamentsDropdown from '@/modules/players/v2/tabs/videos/VideosTournamentsDropdown';
import {
  getYouTubeVideoData,
  isValidYoutubeVideo,
} from '@/modules/players/v2/tabs/videos/videoUtils';
import { YoutubeCards } from '@/modules/players/v2/tabs/videos/YoutubeCards';
import { PlayerVideosData, PlayerVideosTournaments } from '@/types/players.types';

interface SelectedVideosWrapperProps {
  tournaments: PlayerVideosTournaments[];
  videos: PlayerVideosData[];
  totalRecords: number;
}

export const SelectedVideosWrapper = ({
  tournaments,
  videos,
  totalRecords,
}: SelectedVideosWrapperProps) => {
  const validVideos = videos.filter((video) => isValidYoutubeVideo(video.link));
  return (
    <>
      <div className='mb-6'>
        <h2 className='mb-1.5 text-sm text-gray-700'>Tournaments</h2>
        <VideosTournamentsDropdown tournaments={tournaments} />
      </div>
      {validVideos.length === 0 ? (
        <div className='mb-4 flex w-full justify-center rounded-lg border bg-white shadow-md '>
          <div className='py-8 text-gray-900'>No videos found for this player.</div>
        </div>
      ) : (
        <div className='grid w-full grid-cols-1 gap-6 sm:grid-cols-3'>
          {validVideos.map((video) => {
            const url = video.link;
            const { videoId, start } = getYouTubeVideoData(url);
            return (
              <YoutubeCards
                key={`${videoId}-${url}-${video.teamOnePlayerOneFirstName}-${video.teamTwoPlayerOneFirstName}`}
                youtubeVideoId={videoId}
                start={start}
                video={video}
              />
            );
          })}
        </div>
      )}
      <VideosPagination totalRecords={totalRecords} pageSize={12} />
    </>
  );
};
